<div class="row">
    <div class="col-md-12">
      <yt-fw-default-list-modal [CondensedTable]="true" #defaultList></yt-fw-default-list-modal>
    </div>
  </div>